import api from './Api'



const defalutGetAllFeedAndCommentClaimAdminQuery = 'claimId status claimDateTime claimNickName creatorNickName content targetId targetType category hiddenLastUpdatedTime hiddenMemberName'
export const getAllFeedAndCommentClaimAdmin = <T>(responseQuery: string = defalutGetAllFeedAndCommentClaimAdminQuery) => {
    const query = `query GetAllFeedAndCommentClaimAdmin { getAllFeedAndCommentClaimAdmin { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getAllFeedAndCommentClaimAdmin: T }>>('/graphql', { query })
}

const defalutGetFeedAndCommentClaimAdminByTargetClaimIdAndTargetTypeQuery = 'claimId status claimDateTime claimNickName creatorNickName content targetId targetType category hiddenLastUpdatedTime hiddenMemberName'

export const getFeedAndCommentClaimAdminByTargetClaimIdAndTargetType = <T>(targetClaimId: number, targetType: string, responseQuery: string = defalutGetFeedAndCommentClaimAdminByTargetClaimIdAndTargetTypeQuery) => {
    const query = `query GetFeedAndCommentClaimAdminByTargetClaimIdAndTargetType($targetClaimId: ID!, $targetType: String!) { getFeedAndCommentClaimAdminByTargetClaimIdAndTargetType(targetClaimId: $targetClaimId, targetType: $targetType) { ${responseQuery} } }`
    return api.post<IGraphqlResponse<{ getFeedAndCommentClaimAdminByTargetClaimIdAndTargetType: T }>>('/graphql', { query, variables: { targetClaimId, targetType } })
}

export const getFeedAndCommentTotalClaimCntAdminByTargetIdAndTargetType = (targetId: number, targetType: string) => {
    return api.get<number>(`/feed-and-comment/total-claim-cnt/admin/${targetId}/${targetType}`)
}

export const createOrUpdateFeedHiddenAdmin = (createOrUpdateFeedHiddenAdminRequest: ICreateOrUpdateFeedHiddenAdminRequest) => {
    return api.post<boolean>(`/feed-hidden/admin`, createOrUpdateFeedHiddenAdminRequest)
}

export const createOrUpdateFeedCommentHiddenAdmin = (createOrUpdateFeedCommentHiddenAdminRequest: ICreateOrUpdateFeedCommentHiddenAdminRequest) => {
    return api.post<boolean>(`/feed-comment-hidden/admin`, createOrUpdateFeedCommentHiddenAdminRequest)
}

export const getAllFeedHiddenMemoAdminByFeedHiddenId = (feedHiddenId: number) => {
    return api.get<IFeedAndCommentHiddenMemo[]>(`/feed-hidden-memo/admin/${feedHiddenId}`)
}

export const getAllFeedCommentHiddenMemoAdminByFeedCommentHiddenId = (feedCommentHiddenId: number) => {
    return api.get<IFeedAndCommentHiddenMemo[]>(`/feed-comment-hidden-memo/admin/${feedCommentHiddenId}`)
}

export const createFeedHiddenMemoAdmin = (createFeedAndCommentHiddenMemoAdminRequest: ICreateFeedAndCommentHiddenMemoAdminRequest) => {
    return api.post<boolean>(`/feed-hidden-memo/admin`, createFeedAndCommentHiddenMemoAdminRequest)
}
export const createFeedCommentHiddenMemoAdmin = (createFeedAndCommentHiddenMemoAdminRequest: ICreateFeedAndCommentHiddenMemoAdminRequest) => {
    return api.post<boolean>(`/feed-comment-hidden-memo/admin`, createFeedAndCommentHiddenMemoAdminRequest)
}